import React from 'react';

import {noteLinkedAppCanvasCreate} from 'benchling-apps/interactivity/canvases/CanvasDAO';
import GenericCanvasContainer from 'benchling-apps/interactivity/canvases/GenericCanvas/GenericCanvasContainer';
import {ACTION_CREATE_APP_CANVAS} from 'notebook/store/VersioningConstants';
import {
  ActionResultType,
  performServerSideWriteAction,
} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import notifications from 'notifications';
import APIUtil from 'util/APIUtil';

export interface NoteLinkedAppCanvasComponentProps {
  documentId: string;
  appInstallationId: string;
  featureDeveloperDefinedId: string;
  provenanceUuid: string;
  canvasId?: string;
  isLocked: boolean;
  isConfig?: boolean | null;
}

function NoteLinkedAppCanvasComponent(props: NoteLinkedAppCanvasComponentProps): JSX.Element {
  const doCanvasCreate = async (
    featureDeveloperDefinedId: string,
    appInstallationId: string,
    resourceId: string
  ): Promise<void> => {
    await performServerSideWriteAction({
      entryId: resourceId,
      loadingScreenMessage: 'Inserting canvas...',
      autoSaverAction: ACTION_CREATE_APP_CANVAS,
      doPerformAction: async () => {
        try {
          const response = await noteLinkedAppCanvasCreate(resourceId, props.provenanceUuid, {
            featureDeveloperDefinedId,
            appInstallationId,
          });
          const failure = response.deliveryStatus === 'failure';
          if (failure) {
            notifications.error(
              'Could not reach app. Please contact Benchling support if the issue persists.'
            );
          }
          return {
            resultType: ActionResultType.SUCCESS,
            responseData: null,
          };
          // eslint-disable-next-line benchlint/always-throw-from-catch
        } catch (e) {
          notifications.notifyError(e);
          return {
            resultType: ActionResultType.ABORTED,
            responseData: null,
          };
        }
      },
    });
  };
  return (
    <GenericCanvasContainer
      resourceId={props.documentId}
      appInstallationId={props.appInstallationId}
      featureUserDefinedId={props.featureDeveloperDefinedId}
      canvasId={props.canvasId}
      doCreateCanvas={doCanvasCreate}
      forceDisable={props.isLocked}
      canCreateCanvas={
        APIUtil.isEntry(props.documentId) || (APIUtil.isDocument(props.documentId) && !props.isConfig)
      }
    />
  );
}

export default NoteLinkedAppCanvasComponent;
